import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';

@Injectable({
  providedIn: 'root'
})
export class TipoRegistroContableService {

  constructor(private http:HttpClient) {
  }

  create(createKeyValueRequest:CreateKeyValueRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoRegistroContable/Create",createKeyValueRequest);
  }

  update(updateKeyValueRequest:UpdateKeyValueRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoRegistroContable/Update",updateKeyValueRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/TipoRegistroContable/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/TipoRegistroContable/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoRegistroContable/Delete?id=" + id);
    else
      return of(null)
  }

}
